export default (filters, date = undefined) => {
  let filterQuery = ""

  if (filters.length) {
    filterQuery =
      filterQuery +
      "&filter=" +
      encodeURIComponent(
        JSON.stringify(
          filters.map(([key, value, exact, not]) => {
            return { key, value, exact, not }
          })
        )
      )
  }

  if (date) {
    filterQuery = filterQuery + "&date=" + JSON.stringify(date)
  }
  return filterQuery
}
